import React from 'react';
import './AtlasToolbar.css';

const FitIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 3 21 3 21 9" />
    <polyline points="9 21 3 21 3 15" />
    <line x1="21" y1="3" x2="14" y2="10" />
    <line x1="3" y1="21" x2="10" y2="14" />
  </svg>
);

const ResetIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <line x1="12" y1="2" x2="12" y2="6" />
    <line x1="12" y1="18" x2="12" y2="22" />
    <line x1="2" y1="12" x2="6" y2="12" />
    <line x1="18" y1="12" x2="22" y2="12" />
  </svg>
);

const FolderPlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z" />
    <line x1="12" y1="11" x2="12" y2="17" />
    <line x1="9" y1="14" x2="15" y2="14" />
  </svg>
);

const AtlasToolbar = ({
  bounds,
  fitToBounds,
  resetView,
  useDemo,
  organizationReady,
  onCreateRootFolder,
  showCreate,
  createLabel = 'Folder',
  createTitle = 'Create a folder',
  createIcon = null,
  fitTitle = 'Fit folders in view',
  resetTitle = 'Reset zoom and frame folders',
  hint = 'Scroll to zoom · drag to pan · right-drag to select · click a folder to peek',
}) => {
  const canCreate = showCreate ?? (!useDemo && organizationReady);
  return (
    <div className="atlas__toolbar">
      <button
        type="button"
        className="atlas__tool-btn"
        onClick={() => fitToBounds(bounds, 48)}
        title={fitTitle}
      >
        <span className="atlas__tool-btn-icon"><FitIcon /></span>
        <span className="atlas__tool-btn-label">Fit</span>
      </button>
      <button
        type="button"
        className="atlas__tool-btn"
        onClick={resetView}
        title={resetTitle}
      >
        <span className="atlas__tool-btn-icon"><ResetIcon /></span>
        <span className="atlas__tool-btn-label">Reset</span>
      </button>
      {canCreate && (
        <button
          type="button"
          className="atlas__tool-btn"
          onClick={onCreateRootFolder}
          title={createTitle}
        >
          <span className="atlas__tool-btn-icon">{createIcon || <FolderPlusIcon />}</span>
          <span className="atlas__tool-btn-label">{createLabel}</span>
        </button>
      )}
      <span className="atlas__toolbar-hint">{hint}</span>
    </div>
  );
};

export default AtlasToolbar;
